import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Line, VictoryAxis, VictoryLabel } from 'victory';

const X = ({
  tickValues,
  tickFormats,
  angle,
  dx,
  isEmpty,
  label,
  padding
}) => {
  const gridClasses = classnames('particles-axis__grid', 'particles-axis__grid--x', {
    'particles-axis__grid--empty': !!isEmpty
  });
  const tickLabelClasses = classnames('particles-axis__tick-label', 'particles-axis__tick-label--x', {
    'particles-axis__tick-label--empty': !!isEmpty
  });
  const axisLabelClasses = classnames('particles-axis__axis-label', 'particles-axis__axis-label--x', {
    'particles-axis__axis-label--empty': !!isEmpty
  });
  const axisClasses = classnames('particles-axis__axis', 'particles-axis__axis--x', {
    'particles-axis__axis--empty': !!isEmpty
  });
  const tickClasses = classnames('particles-axis__tick', 'particles-axis__tick--x', {
    'particles-axis__tick--empty': !!isEmpty
  });
  return (
    <VictoryAxis
      label={label}
      key="x-axis"
      style={{ ticks: { size: 5 }, axisLabel: { padding } }}
      tickComponent={<Line type="tick" className={tickClasses} />}
      axisComponent={<Line type="axis" className={axisClasses} />}
      gridComponent={<Line type="grid" className={gridClasses} />}
      tickLabelComponent={<VictoryLabel className={tickLabelClasses} angle={angle} dx={dx} />}
      axisLabelComponent={<VictoryLabel className={axisLabelClasses} />}
      tickValues={tickValues}
      tickFormat={tickFormats}
    />
  );
};

X.propTypes = {
  padding: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  tickValues: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  tickFormats: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    PropTypes.func
  ]),
  angle: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dx: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isEmpty: PropTypes.oneOfType([PropTypes.bool]),
  label: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

X.defaultProps = {
  padding: 20,
  tickValues: [0],
  tickFormats: [0],
  angle: 0,
  dx: 0,
  label: '',
  isEmpty: false
};

X.displayName = 'Chart.Axis.X';

export default X;

export const {
  propTypes,
  defaultProps,
  displayName
} = X;
